export const SIDE_PANEL_TEST_ID = 'SidePanel';
